import React, { useState, useEffect } from 'react';

const imageCache = {};

function CachedImage({ src, alt, style }) {
  const [cachedSrc, setCachedSrc] = useState(null);
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  useEffect(() => {
    setIsImageLoaded(false);

    if (imageCache[src]) {
      setCachedSrc(imageCache[src]);
    } else {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = src;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        imageCache[src] = dataURL;
        setCachedSrc(dataURL);
      };
      img.onerror = () => {
        console.error(`Failed to load image: ${src}`);
        setCachedSrc(src);
      };
    }
  }, [src]);

  const imageStyle = {
    ...style,
    opacity: isImageLoaded ? 1 : 0,
    transition: 'opacity 0.5s ease-in-out',
  };

  // Placeholder: show your local firstimage.jpg until the real one is ready
  if (!cachedSrc) {
    return (
      <img src="/assets/firstimage.jpg" 
        style={style}
      />
    );
  }

  return (
    <img
      src={cachedSrc}
      alt={alt}
      style={imageStyle}
      onLoad={() => setIsImageLoaded(true)}
    />
  );
}

export default CachedImage;
